import axios from '../services/request'

/* 登录 */
export const Login = (data = {}) => axios.post('api/user/login',data);

/* 退出 */
export const Logout = (data = {}) => axios.post('api/user/logout',data);

/* 退出 */
export const getinfo = (data = {}) => axios.get('api/user/getinfo',data);


export default{
    Login,
    Logout,
    getinfo
}